<template>
  <div class="google-reviews">
    <h2 class="mb-4 text-center ff-t3 text-white">Ils nous ont noté 5 étoiles ⭐</h2>

    <div v-if="loading">Chargement des avis...</div>

    <div v-else class="row g-4">
      <div
        v-for="review in displayedReviews"
        :key="review.time + review.author_name"
        class="col-md-4"
      >
        <div class="card h-100">
          <div class="card-body">
           
            <p class="text-warning">
              ★★★★★
            </p>
            <p class=" text-gray-700/o80" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; color:gray;">
              "{{ review.text }}"
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GoogleReviews",
  data() {
    return {
      reviews: [],
      displayedReviews: [],
      loading: true,
      intervalId: null,
    };
  },
  computed: {
    fiveStarsReviews() {
      return this.reviews.filter(r => r.rating === 5);
    }
  },
  methods: {
    // Fonction pour choisir 3 avis aléatoires parmi les 5
    shuffleReviews() {
      if (this.fiveStarsReviews.length === 0) return;
      
      const shuffled = [...this.fiveStarsReviews].sort(() => 0.5 - Math.random());
      this.displayedReviews = shuffled.slice(0, 3);
    }
  },
  async mounted() {
    try {
      const res = await fetch("https://admin.mia-restaurant.fr/reviews");
      const data = await res.json();
      this.reviews = data || [];
      console.log(this.reviews)
      this.shuffleReviews();

      // Changer les avis toutes les 10 secondes
      this.intervalId = setInterval(() => {
        this.shuffleReviews();
      }, 10000);

    } catch (e) {
      console.error("Erreur récupération avis Google", e);
    } finally {
      this.loading = false;
    }
  },
  beforeUnmount() {
    // Nettoyer l'intervalle pour éviter les fuites mémoire
    if (this.intervalId) clearInterval(this.intervalId);
  }
};
</script>

<style scoped>
.google-reviews {
  margin-top: 60px;
}
.card {
  border-radius: 12px;
}
</style>
